import { create } from 'zustand';
import type { UserSession } from '../types';

interface AuthState {
  token?: string;
  user?: UserSession;
  organizationName?: string;
  setSession: (token: string, user: UserSession, organizationName: string) => void;
  logout: () => void;
  has: (permission: string) => boolean;
}

const saved = (() => {
  try { return JSON.parse(localStorage.getItem('pgas-session') || '{}'); } catch { return {}; }
})();

export const useAuth = create<AuthState>((set, get) => ({
  token: saved.token,
  user: saved.user,
  organizationName: saved.organizationName,
  setSession: (token, user, organizationName) => {
    const value = { token, user, organizationName };
    localStorage.setItem('pgas-session', JSON.stringify(value));
    set(value);
  },
  logout: () => { localStorage.removeItem('pgas-session'); set({ token: undefined, user: undefined, organizationName: undefined }); },
  has: (permission) => Boolean(get().user?.permissions.includes(permission)),
}));
